const E = {
  title: 'Customer Portal Login',
  sub: 'Secure access to your results and more',
  form: {
    name: {
      label: 'Name',
      error: 'Name is a required field',
    },
    company: {
      label: 'Company',
      error: 'Company is a required field',
    },
    phone: {
      label: 'Phone',
      error: 'Phone is a required field',
      error_valid: 'Phone number is not valid',
    },
    ext: {
      label: 'Ext',
    },
    email: {
      label: 'Email Address',
      error: 'Invalid email format',
    },
    region: {
      label: 'Region',
      error: 'Please select a region',
    },
    language: {
      label: 'Language',
      error: 'Please select a language',
    },
    service: {
      label: 'Service',
    },
    services: {
      environmental: 'Environmental',
      food: 'Food',
      petroleum: 'Petroleum',
      Hygiene: 'Industrial Hygiene',
    },
    buttons: {
      submit: 'submit',
      cancel: 'cancel',
    },
  },
  complete: {
    title: 'Customer Portal Registration',
    sub: 'Registration submitted',
    message:
      'A  Bureau Veritas representative will contact you shortly to complete the registration process.',
    form: {
      buttons: {
        return: 'return to Login',
      },
    },
  },
};

const F = {
  title: 'Connexion au Portail Client',
  sub: 'Accès sécurisé à vos résultats et plus encore',
  form: {
    name: {
      label: 'Nom',
      error: 'Le nom est un champ obligatoire',
    },
    company: {
      label: 'Nom de l’entreprise',
      error: 'L’entreprise est un champ obligatoire',
    },
    phone: {
      label: 'Téléphone',
      error: 'Le téléphone est un champ obligatoire',
      error_valid: 'Le numéro de téléphone n’est pas valide',
    },
    ext: {
      label: 'Poste',
    },
    email: {
      label: 'Adresse courriel',
      error: 'Le format de l’adresse de courrier électronique est inexact',
    },
    region: {
      label: 'Région',
      error: 'Veuillez choisir une région',
    },
    language: {
      label: 'Langues',
      error: 'Veuillez choisir une langue',
    },
    service: {
      label: 'Service',
    },
    services: {
      environmental: 'Environnement',
      food: 'Alimentaire',
      petroleum: 'Pétrole',
      Hygiene: 'Hygiène industrielle',
    },
    buttons: {
      submit: 'Soumettre',
      cancel: 'Annuler',
    },
  },
  complete: {
    title: 'Inscription au portail client',
    sub: 'Inscription soumise',
    message:
      "Un représentant Bureau Veritas vous contactera sous peu pour compléter le processus d'inscription.",
    form: {
      buttons: {
        return: 'Revenir à la page de connexion',
      },
    },
  },
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/registration.js